import {
  PiCertificateFill,
  PiScales,
  PiHouseLineFill,
  PiHammerFill,
  PiGraduationCapFill,
  PiGavelFill,
  PiBookOpenFill,
  PiChalkboardTeacherFill,
  PiCalculatorFill,
  PiMicroscopeFill,
  PiStethoscopeFill,
  PiPillFill,
  PiMedalFill,
  PiShieldCheckFill,
  PiAtomFill,
  PiPlantFill,
  PiFlaskFill,
  PiHandshakeFill,
  PiBriefcaseFill,
  PiChartLineUpFill,
  PiGlobeFill,
  PiCurrencyDollarFill,
  PiBankFill,
  PiTreeStructureFill,
  PiFileTextFill,
  PiRulerFill,
  PiCpuFill,
  PiGitMergeFill,
  PiMathOperationsFill,
  PiNumberSquareOneFill,
  PiNotebookFill,
  PiLockFill,
  PiCalendarCheckFill,
} from "react-icons/pi";

export const examsHashtags = {
  // Alberta, Canada
  "alberta-diploma-examination-canada": {
    icon: PiCertificateFill,
    desc: "Standardized high school graduation exams for Alberta students",
  },
  "law-cpled-bar-admission-program-canada": {
    icon: PiScales,
    desc: "Required program for law graduates to practice in Canada",
  },
  "real-estate-reca-exams-canada": {
    icon: PiHouseLineFill,
    desc: "Licensing exams for Alberta real estate professionals",
  },
  "trades-ait-exams-canada": {
    icon: PiHammerFill,
    desc: "Certification exams for skilled trades in Alberta",
  },

  // British Columbia, Canada
  "bc-provincial-graduation-assessments-canada": {
    icon: PiGraduationCapFill,
    desc: "Mandatory assessments for BC high school graduation",
  },
  "bar-admission-in-british-columbia-canada": {
    icon: PiGavelFill,
    desc: "Licensing process for lawyers in British Columbia",
  },
  "real-estate-licensing-in-bc-canada": {
    icon: PiHouseLineFill,
    desc: "Exams required to become a licensed realtor in BC",
  },

  // Ontario, Canada
  "osslt-ontario-canada": {
    icon: PiBookOpenFill,
    desc: "Literacy test required for Ontario high school diploma",
  },
  "oct-certification-ontario-canada": {
    icon: PiChalkboardTeacherFill,
    desc: "Certification exams for Ontario teaching professionals",
  },
  "barrister-solicitor-exams-ontario-canada": {
    icon: PiScales,
    desc: "Licensing exams for Ontario lawyers and solicitors",
  },
  "orea-exams-ontario-canada": {
    icon: PiHouseLineFill,
    desc: "Ontario real estate salesperson licensing examinations",
  },
  "cpa-ontario-exams-ontario-canada": {
    icon: PiCalculatorFill,
    desc: "Chartered Professional Accountant certification exams for Ontario",
  },

  // Medical & Healthcare
  mcat: {
    icon: PiMicroscopeFill,
    desc: "Standardized test for medical school admissions",
  },
  nclex: {
    icon: PiStethoscopeFill,
    desc: "National exam for registered nurse licensure",
  },
  nclexrn: {
    icon: PiStethoscopeFill,
    desc: "National exam for registered nurse licensure",
  },
  "nclex-pn": {
    icon: PiStethoscopeFill,
    desc: "Licensing exam for practical/vocational nurses",
  },
  naplex: {
    icon: PiPillFill,
    desc: "North American pharmacist licensing examination",
  },
  "usmle-united-states-medical-licensing-examination-usa": {
    icon: PiMedalFill,
    desc: "Three-step examination for US medical licensure",
  },
  "plab-professional-and-linguistic-assessments-board-uk": {
    icon: PiShieldCheckFill,
    desc: "UK medical licensing test for international graduates",
  },
  "neet-national-eligibility-cum-entrance-test-india": {
    icon: PiAtomFill,
    desc: "Single entrance exam for Indian medical colleges",
  },
  "bmat-biomedical-admissions-test-uk-other-countries": {
    icon: PiPlantFill,
    desc: "Admissions test for UK biomedical science programs",
  },
  "gamsat-graduate-medical-school-admissions-test-australia-ireland-uk": {
    icon: PiFlaskFill,
    desc: "Graduate-level medical school admissions test",
  },
  "comlex-usa-comprehensive-osteopathic-medical-licensing-examination-usa": {
    icon: PiHandshakeFill,
    desc: "Licensing exam for osteopathic physicians in US",
  },
  "dha-exam-dubai-health-authority-dubai": {
    icon: PiShieldCheckFill,
    desc: "Dubai healthcare practitioner licensing examination",
  },

  // Business & Management
  "gmat-graduate-management-admission-test-global": {
    icon: PiBriefcaseFill,
    desc: "Standardized test for business school admissions",
  },
  "cat-common-admission-test-india": {
    icon: PiChartLineUpFill,
    desc: "Entrance exam for Indian management institutes",
  },
  "gre-graduate-record-examinations-global": {
    icon: PiGlobeFill,
    desc: "General test for graduate school admissions",
  },
  "cfa-chartered-financial-analyst-global": {
    icon: PiCurrencyDollarFill,
    desc: "Professional credential for investment analysts",
  },
  "cpa-certified-public-accountant-usa-global": {
    icon: PiCalculatorFill,
    desc: "Professional accounting qualification in the US",
  },
  "cma-certified-management-accountant-global": {
    icon: PiBankFill,
    desc: "Global certification for management accountants",
  },
  "togaf-open-group-architecture-framework-global": {
    icon: PiTreeStructureFill,
    desc: "Enterprise architecture framework certification",
  },

  // Law
  "lsat-law-school-admission-test-usa-canada-global": {
    icon: PiScales,
    desc: "Standardized test for law school admissions",
  },
  "bar-exam-various-countries": {
    icon: PiGavelFill,
    desc: "Licensing examination for legal practitioners",
  },
  "clat-common-law-admission-test-india": {
    icon: PiFileTextFill,
    desc: "National level law entrance exam in India",
  },
  "lnat-law-national-aptitude-test-uk": {
    icon: PiBookOpenFill,
    desc: "UK law school admissions aptitude test",
  },
  "sqe-solicitors-qualifying-examination-uk": {
    icon: PiScales,
    desc: "New pathway to qualify as a UK solicitor",
  },

  // Engineering & Technical
  "fe-exam-fundamentals-of-engineering-usa": {
    icon: PiRulerFill,
    desc: "First step toward professional engineering license",
  },
  "pe-exam-professional-engineering-usa": {
    icon: PiCpuFill,
    desc: "Final examination for professional engineering licensure",
  },
  "gate-graduate-aptitude-test-engineering-india": {
    icon: PiGitMergeFill,
    desc: "National level examination for engineering graduates",
  },
  "jee-joint-entrance-examination-india": {
    icon: PiMathOperationsFill,
    desc: "Engineering entrance examination for Indian institutes",
  },
  "eit-exam-engineer-in-training-usa": {
    icon: PiNumberSquareOneFill,
    desc: "Certification for engineers working toward licensure",
  },

  // Miscellaneous
  "sat-scholastic-assessment-test-usa": {
    icon: PiNotebookFill,
    desc: "Standardized test for US college admissions",
  },
  "act-american-college-testing-usa": {
    icon: PiFileTextFill,
    desc: "Alternative college readiness assessment in US",
  },
  "ib-international-baccalaureate-global": {
    icon: PiGlobeFill,
    desc: "International high school diploma program",
  },
  "cissp-certified-information-systems-security-professional-global": {
    icon: PiLockFill,
    desc: "Advanced cybersecurity certification for professionals",
  },
  "pmp-project-management-professional-global": {
    icon: PiCalendarCheckFill,
    desc: "Globally recognized project management certification",
  },
};
